import {updateDates} from '../../../../commons/actions/dates'
import {getComponentData} from '../actions/component'
import {getEvents} from '../actions/events'

export const datesMiddleware = store => next => action => {
  switch (action.type) {
    case getComponentData.fulfilled.toString():
    case getEvents.fulfilled.toString(): {
      store.dispatch(updateDates(action.payload.dates))
      break
    }
    default:
      break
  }
  next(action)
}
